// components/Bootstrap/Modal/Modal.js

import React from 'react';
import './Modal.css'

/**
 * Para validación de props, no viene por defecto, instalar: npm install prop-types
 */
import PropTypes from 'prop-types';

/**
 * Modal - Componente reutilizable para mostrar un modal de Bootstrap.
 *
 * @param {boolean} show - Indica si el modal debe estar visible.
 * @param {function} onClose - Función a ejecutar cuando se cierre el modal.
 * @param {string} title - Título que se muestra en el encabezado del modal.
 * @param {React.ReactNode} children - Contenido que se renderiza dentro del cuerpo del modal.
 */
const Modal = ({ show, onClose, id = '', title, children, footer = '', width = 'auto', className = '', zIndex }) => {
    const modalStyle = { display: 'block', ...(zIndex ? { zIndex } : {}) };
    const backdropStyle = zIndex ? { zIndex: zIndex - 1 } : {};
    return (
        <>
            {show && (
                <>
                    <div
                        className={`modal fade show eol-modal${className ? ` ${className}` : ''}`}
                        tabIndex="-1"
                        style={modalStyle}
                        id={id}
                    >
                        <div
                            className={`modal-dialog modal-dialog-centered ${width === 'full' ? 'modal-fullscreen' : ''}`}
                        >
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{title}</h5>
                                    <button type="button" className="btn-close" onClick={onClose} />
                                </div>
                                <div className="modal-body" style={{ flex: 1 }}>{children}</div>
                                <div className="modal-footer">{footer}</div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show" style={backdropStyle} onClick={onClose}></div>
                </>
            )}
        </>
    );
};


// PropTypes para validar las props del componente
Modal.propTypes = {
    /**
     * Indica si el modal debe estar visible.
     */
    show: PropTypes.bool.isRequired,

    /**
     * Función a ejecutar cuando se cierre el modal.
     */
    onClose: PropTypes.func.isRequired,

    /**
     * Título que se muestra en el encabezado del modal.
     */
    title: PropTypes.string,

    /**
     * Contenido que se renderiza dentro del cuerpo del modal.
     */
    children: PropTypes.node,
};

// Valores predeterminados para las props opcionales
Modal.defaultProps = {
    title: '', // Título por defecto si no se proporciona
};

export default Modal;
